import { observer } from 'mobx-react-lite'

import Stack from '@mui/material/Stack'

import { Text } from '@mxenabled/mxui'

import { useBudgetsStore, useGlobalCopyStore, useRecurringTransactionsStore } from '../../../common'
import { formatCurrency } from '../../../core/utils/NumberFormatting'

export const Header = observer(() => {
  const { budgets: copy } = useGlobalCopyStore()
  const { totalBudgeted } = useBudgetsStore()
  const { incomeTotal } = useRecurringTransactionsStore()

  const remaining = incomeTotal - totalBudgeted

  return (
    <Stack direction="row" justifyContent="center" my={16} spacing={20}>
      <Stack alignItems="center">
        <Text bold={true} variant="body1">
          {formatCurrency(incomeTotal, '0,0')}
        </Text>
        <Text color="secondary" variant="body2">
          {copy.projected_income}
        </Text>
      </Stack>

      <Text bold={true} justifyContent="center" variant="body1">
        {'-'}
      </Text>

      <Stack alignItems="center">
        <Text bold={true} variant="body1">
          {formatCurrency(totalBudgeted, '0,0')}
        </Text>
        <Text color="secondary" variant="body2">
          {copy.budgeted}
        </Text>
      </Stack>

      <Text bold={true} justifyContent="center" variant="body1">
        {'='}
      </Text>

      <Stack alignItems="center">
        <Text bold={true} variant="body1">
          {formatCurrency(remaining, '0,0')}
        </Text>
        <Text color="secondary" variant="body2">
          {copy.remaining}
        </Text>
      </Stack>
    </Stack>
  )
})
